import React from 'react';
import { useTranslation } from 'react-i18next';
import { EosLawVersion } from '../../../../../models/payroll';
import type { ComplianceCountry } from '../../../../../models/general';

interface Props {
  lawVersion: EosLawVersion;
  hireDate: string;
  country: ComplianceCountry;
}

export const LawVersionBanner: React.FC<Props> = ({ lawVersion, hireDate, country }) => {
  const { t } = useTranslation('common');

  // KSA gratuity is statutory (Art. 84/85) with no hire-date law-version split — a single informational note.
  if (country === 'KSA') {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300">
        <span className="mt-0.5 text-blue-500">ℹ</span>
        <div>
          <p className="font-semibold">{t('KSA Labour Law (Articles 84-85)')}</p>
          <p className="mt-0.5 text-blue-700 dark:text-blue-400">
            {t('Gratuity is half a month\'s wage per year for the first 5 years and a full month per year thereafter, computed on the last wage (basic plus fixed allowances). Resignation reduces the award under Art. 85.')}
          </p>
        </div>
      </div>
    );
  }

  if (lawVersion === 'NewLaw') {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-300">
        <span className="mt-0.5 text-blue-500">ℹ</span>
        <div>
          <p className="font-semibold">{t('FDL 33/2021 Applies')}</p>
          <p className="mt-0.5 text-blue-700 dark:text-blue-400">
            {t('All departure reasons receive full gratuity under the new UAE Labour Law.')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300">
      <span className="mt-0.5 text-amber-500">⚠</span>
      <div>
        <p className="font-semibold">{t('FL 8/1980 May Apply')}</p>
        <p className="mt-0.5 text-amber-700 dark:text-amber-400">
          {t('Employee was hired before Feb 2022. HR must verify departure reason and contract type for correct multiplier.')}
        </p>
        <p className="mt-1 text-xs text-amber-600 dark:text-amber-500">
          {t('Hire date')}: {new Date(hireDate).toLocaleDateString('en-GB')}
        </p>
      </div>
    </div>
  );
};
